@if (product.program.photos.length > 0) {
  <pr-swiper class="swiper-container" [swiperMinWidth]="0" [config]="config">
    @for (slide of product.program.photos; track slide) {
      <pr-slide class="swiper-slide">
        <div
          [ngStyle]="{
            'background-image': 'url(' + slide + ')',
            height: '100%',
            width: '100%',
            'background-size': 'cover',
          }"
        ></div>
      </pr-slide>
    }
  </pr-swiper>
}
@if (product.program.photos.length == 0) {
  <div
    class="img-placeholder"
    style="background-image: url('/gp/assets/img/gridky-placeholder.png')"
  ></div>
}

<div class="swiper-badge">
  <pr-label name="sp-award" labelDefaultClass="text-white fs-13 fw-600"
    >SELECTION SUR MESURE</pr-label
  >
</div>
